import getApi from '../../api/apisauceConfig'
import { deserializeQuestionInstanceResponse } from './mapper/questionInstances.mapper'
import { QuestionInstanceResource } from './mapper/questionInstances.model'

export const getQuestionInstance = (id: number) =>
  getApi()
    .get<QuestionInstanceResource>(`/question_instances/${id}`)
    .then(deserializeQuestionInstanceResponse)
